import(/* webpackMode: "eager" */ "/vercel/path0/app/solutions/reverse-auction/page.tsx");
